function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add_to_cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "ic_add to cart"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .75A.751.751 0 0 1 .756 0H2.19a1.766 1.766 0 0 1 1.595 1h12.954a1.251 1.251 0 0 1 1.217 1.575l-1.293 4.759A2.27 2.27 0 0 1 14.473 9H5.38l.17.891a.758.758 0 0 0 .744.609h9.086a.75.75 0 1 1 0 1.5H6.294a2.262 2.262 0 0 1-2.228-1.828L2.439 1.7a.25.25 0 0 0-.249-.2H.756A.751.751 0 0 1 0 .75zM4.034 14.5A1.513 1.513 0 1 1 5.547 16a1.506 1.506 0 0 1-1.513-1.5zm10.59-1.5a1.5 1.5 0 1 1-1.513 1.5 1.506 1.506 0 0 1 1.513-1.5zM7.942 5a.63.63 0 0 0 .63.625h1.387V7a.63.63 0 0 0 1.261 0V5.625h1.387a.625.625 0 1 0 0-1.25H11.22V3a.63.63 0 0 0-1.261 0v1.375H8.573A.63.63 0 0 0 7.942 5z",
    transform: "translate(3 4)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add_to_cart.5a062711e84d26f63ab598734f64f3cb.svg";
export { ForwardRef as ReactComponent };